import {
  SET_REVIEW_CATEGORY,
  ReviewCategoryState,
  ReviewCategoryActionTypes,
} from '../types';

const initialState: ReviewCategoryState = {
  reviewCategoryMap: {},
};

function ReviewCategoryReducer(
  state: ReviewCategoryState = initialState,
  action: ReviewCategoryActionTypes,
): ReviewCategoryState {
  switch (action.type) {
    case SET_REVIEW_CATEGORY:
      return {
        ...state,
        reviewCategoryMap: action.payload,
      };
    default:
      return state;
  }
}

export default ReviewCategoryReducer;
